import React from 'react'
import { toast } from 'react-toastify'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import PaymentAPI from 'api/faber/PaymentAPI'
import CrossDialogBtn from 'common/Button/CrossDialogBtn'
import NormalText from 'common/Typography/NormalText'

import { PaperComponent } from './UpdateFaberUserDetailsDialog'
function RefundUpdateStatusDialogV2({
  dialogOpen,
  handleDialogClose,
  paymentId,
  faberToken
}: RefundStatusDialogProps) {
  const { mutate: updateRefundRequest, isLoading: isRefundUpdateLoading } =
    useMutation(PaymentAPI.updateRefundRequestV2, {
      onSuccess: () => {
        toast.success('Refund update Success')
      },
      onError: () => {
        toast.error('Refund update error')
      },
      onSettled: () => {
        handleDialogClose()
      }
    })

  const handleConfirmRefundStatus = () => {
    updateRefundRequest({
      refundPaymentID: paymentId,
      faberToken
    })
  }

  return (
    <Dialog
      open={dialogOpen}
      maxWidth='sm'
      fullWidth={true}
      onClose={handleDialogClose}
      PaperComponent={PaperComponent}
      aria-labelledby='draggable-dialog-title'
    >
      <Box sx={{ py: 2, px: 0 }}>
        <DialogTitle
          sx={{
            margin: '0',
            fontWeight: '700',
            color: 'black',
            fontSize: '21px',
            mt: '4px',
            px: 3
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: '1em', mx: 2 }}>
              Update Refund Status
            </Typography>
            <CrossDialogBtn dialogClose={handleDialogClose} />
          </Box>
          <NormalText sx={{ px: 2, my: 0, color: 'primary.dark', mx: 0 }}>
            Payment ID: {paymentId}
          </NormalText>
        </DialogTitle>

        <DialogContent sx={{ px: 3 }}>
          <NormalText sx={{ px: 2 }}>
            This will update the refund status from <b>PENDING</b> to{' '}
            <b>SUCCESS</b>. Please note, after clicking confirm, it will update
            the status immediately.
          </NormalText>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <LoadingButton
              variant='contained'
              onClick={handleConfirmRefundStatus}
              loadingIndicator={<CircularProgress size={16} />}
              loading={isRefundUpdateLoading}
            >
              Confirm
            </LoadingButton>
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  )
}

export default RefundUpdateStatusDialogV2

interface RefundStatusDialogProps {
  dialogOpen: boolean
  handleDialogClose: () => void
  paymentId: string
  faberToken: string
}
